module.exports = __webpack_public_path__ + "images/category_lp/brand_samples/pattern_new3/main_pc_16505bd934809a544cd463ad42f2ac13.jpg";